import { ReactNode } from "react";

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

export function PageLayout({ children, className = "" }: PageLayoutProps) {
  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--text-primary)" }}>
      <main
        className={`flex-1 flex flex-col px-7 pt-[96px] pb-[60px] max-w-[1240px] mx-auto w-full max-[600px]:px-3.5 max-[600px]:pt-[76px] ${className}`}
      >
        {children}
      </main>
    </div>
  );
}
